import React from "react";
import { Column } from "@ant-design/plots";

export default function ColumnChart({
  data,
  h1,
  color, // ✅ global color
  colorFromSchool = false,
  schools = [],
  colorMap = {},
  height = 400,
  maxYLabel,
}) {
  const ddata = [
    { type: "分类一", value: 270 },
    { type: "分类二", value: 25 },
    { type: "分类三", value: 18 },
    { type: "分类四", value: 15 },
    { type: "分类五", value: 10 },
    { type: "其他", value: 5 },
  ];

  const config = {
    data: data || ddata,
    xField: "type",
    yField: "value",
    height,
    maxColumnWidth: 80, // ✅ max width in px
    label: {
      position: "middle",
      style: {
        fill: "#FFFFFF",
        opacity: 0.6,
        fontSize: 16,
      },
    },

    xAxis: {
      label: {
        autoHide: false,
        autoRotate: true,
      },
    },

    yAxis: {
      min: 0,
      max: maxYLabel ? maxYLabel : undefined,
      nice: false,
      tickCount: 5,
      label: {
        formatter: (v) => `${Math.round(v)}`,
      },
    },

    columnStyle: {
      borderWidth: 1,
    },

    color: ({ type }) => {
      // 1️⃣ Global color override
      if (color) {
        return color;
      }

      // 2️⃣ School-based color
      if (colorFromSchool && type) {
        const school = schools.find((s) => s.schoolinitials === type);
        if (school?.rowingcolors?.length) {
          return school.rowingcolors[0];
        }
      }

      // 3️⃣ Predefined color map
      if (type && colorMap[type]) {
        return colorMap[type];
      }

      // 4️⃣ Fallback
      return "#5B8FF9";
    },
  };

  return <Column {...config} />;
}
